<script setup>
import { onMounted, ref, reactive } from 'vue'
import { getBankListAPI, getCreateBankOrderAPI, } from '@/apis/wallet'
import { useUserStore } from '@/stores/userStore'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const props = defineProps(['model'])
const emits = defineEmits(['handleClose', 'getList'])
const userStore = useUserStore()
/**
 * 获取银行
 */
const bankList = ref([])
const getBankList = async () => {
    let data = {
        status: 1,
        page: 1,
        page_size: 1000,
    }
    const res = await getBankListAPI(data)
    if (res.code == 0) {
        bankList.value = res.data.list
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const carditem = ref({})
const setCard = (item) => {
    if(data.createOrder.order_credit){
        if (parseFloat(data.createOrder.order_credit) > item.credit_limit) {
            // 如果金额超过信用额度，不选中
            ElMessage({ type: 'warning', message: t('setup577')})
            return;
        }
        console.log(data.createOrder.order_credit)
        console.log(item)
        carditem.value = item
        data.createOrder.bank_id = item.id
        data.createOrder.bank_name = item.bank_name
    }
   
}

const data = reactive({

    createOrder: {
        bank_id: null,
        bank_name: '',
        order_credit: null
    },

})
/**
 * 充值
 */
const setCreateBankOrder = async () => {
    data.createOrder.order_credit = parseInt(data.createOrder.order_credit)
    const res = await getCreateBankOrderAPI(data.createOrder)
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('cart73') })
        handleClose(1, res.data.order_no)
        userStore.getUser()
        emits('getList')
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
//复制
const handleCopy = async (text) => {
    navigator.clipboard.writeText(text)
        .then(() => {
            ElMessage({ type: 'success', message: t('cart74') });
        })
        .catch(err => {
            ElMessage({ type: 'error', message: t('cart75') });
        });
    // try {
    //     await toClipboard(text);
    //     ElMessage({ type: 'success', message: t('cart74') });
    // } catch (e) {
    //     ElMessage({ type: 'error', message: t('cart75') });
    // }
}
const handleClose = (type, id) => {

    emits('handleClose', false, type, id,)
    data.createOrder = {}
}
// 监听输入框的值变化

const num = ref()
const handleInput = (value) => {
    console.log(111)
    // 替换掉所有非数字和小数点的字符
    num.value = value.replace(/[^0-9.]/g, '');
    // 如果小数点后的数字超过两位，则截取到两位小数
    if (num.value.indexOf('.') !== -1) {
        const parts = num.value.split('.');
        const decimalPart = parts[1];
        if (decimalPart.length > 2) {
            num.value = parts[0] + '.' + decimalPart.slice(0, 2);
        }
    }
     // 根据输入金额更新银行列表的可选状态
     bankList.value = bankList.value.map((bank) => ({
        ...bank,
        disabled: parseFloat(value) > bank.credit_limit,
      }));
      const bankData = bankList.value.find((bank) => bank.id === carditem.value.id);
     
      if (bankData && bankData.disabled == true) {
     
        carditem.value = {}; // 如果 disabled 为 "true"，将 bankList.value 设置为空对象
     
        data.createOrder.bank_id = null
        data.createOrder.bank_name = ""
      }
      console.log( bankList.value)
      console.log(carditem.value.id)
}
onMounted(() => {
    getBankList()
})
</script>
<template>
    <div>
        <div class="pc">
            <el-dialog v-model="props.model" :title="t('cart80')" class="pc" width="500" :before-close="handleClose">
                <div class="dialogcontent">

                    <div class="title">{{ $t('cart79') }}</div>
                    <el-input v-model="data.createOrder.order_credit" @input="handleInput" placeholder="Please input">
                        <template #prepend>$</template>
                    </el-input>
                    <div class="title" style="margin-top: 20px;">{{ $t('cart78') }}</div>
                    <div class="CardList">
                        <div :class="carditem.id == item.id ? 'checkItemCard' : 'itemCard'" @click="setCard(item)"
                            v-for="(item, i) in bankList" :key="i">
                            <div class="item-line">
                                <div>{{
                                    item.bank_name }}</div>
                                <div>
                                    <img class="check-icon" v-if="carditem.id == item.id"
                                        src="../../assets/images/check.png" />
                                    <img class="check-icon" v-else src="../../assets/images/nocheck.png" />
                                </div>
                            </div>
                            <div class="item-info" v-show="carditem.id == item.id">
                                <div class="title" style="padding-top: 10px;" v-if="carditem.proportion">
                                    <div>{{ $t('cart76') }} ：{{ carditem.proportion }}</div>
                                </div>
                                <div class="icon-line">
                                    <div class="title" v-if="carditem.telegram">
                                        <div class="unselectable"><a :href="`${carditem.telegram}`" target="_blank"
                                                rel="nofollow" class="button"
                                                style="display: inline-block;padding-right: 10px;width: 36px;height: 26px;">
                                                <img src="../../assets/images/telegram.png"
                                                    style="width: 26px;height: 26px;" alt="" srcset="">

                                            </a>
                                            <span style="padding-right: 10px;">{{ carditem.telegram }}</span>
                                            <el-button type="warning" @click="handleCopy(carditem.telegram)"
                                                size="small" style="margin-right:10px;border:none" plain>{{
                                                    $t('setup60') }}</el-button>
                                        </div>
                                    </div>
                                    <div class="title" v-if="carditem.whats_app">
                                        <div class="unselectable"> <a :href="`${carditem.whats_app}`" target="_blank"
                                                rel="nofollow" class="button"
                                                style="display: inline-block;padding-right: 10px;width: 36px;height: 26px;">
                                                <img src="../../assets/images/watch.png"
                                                    style="width: 26px;height: 26px;border-radius: 50%;    " alt=""
                                                    srcset="">
                                            </a>
                                            <span style="padding-right: 10px;">{{ carditem.whats_app }}</span>
                                            <el-button type="warning" @click="handleCopy(carditem.whats_app)"
                                                size="small" style="margin-right:10px;border:none" plain>{{
                                                    $t('setup60') }}</el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="copy" v-if="carditem.paypal_address">
                                    <el-input style="height: 38px;" v-model="carditem.paypal_address" disabled />
                                    <el-button type="warning" @click="handleCopy(carditem.paypal_address)" size="small"
                                        style="margin-left: 10px;height: 38px;border:none">{{ $t('setup60')
                                        }}</el-button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- <div style="padding-top: 10px;" class="title" v-if="carditem.credit_limit">
    <div>{{$t('cart77')}}：{{carditem.credit_limit}}</div>
</div> -->

                </div>
                <template #footer>
                    <div class="dialog-footer">
                        <div @click="setCreateBankOrder()"> {{ $t('cart8') }}</div>
                    </div>
                </template>
            </el-dialog>
        </div>
        <div class="phone">
            <el-drawer v-model="props.model" :title="t('cart80')" class="phone" show-close :with-header="true"
                direction="btt" :before-close="handleClose" size="80%">
                <!-- <el-dialog v-model="props.model" :title="t('cart80')" class="phone" width="95%" :before-close="handleClose"> -->
                <div class="dialogcontent">

                    <div class="title">{{ $t('cart79') }}</div>
                    <el-input v-model="data.createOrder.order_credit" @input="handleInput" placeholder="Please input">
                        <template #prepend>$</template>
                    </el-input>
                    <div class="title" style="margin-top: 20px;">{{ $t('cart78') }}</div>
                    <div class="CardList">
                        <div :class="carditem.id == item.id ? 'checkItemCard' : 'itemCard'" @click="setCard(item)"
                            v-for="(item, i) in bankList" :key="i">
                            <div class="item-line">
                                <div>{{
                                    item.bank_name }}</div>
                                <div>
                                    <img class="check-icon" v-if="carditem.id == item.id"
                                        src="../../assets/images/check.png" />
                                    <img class="check-icon" v-else src="../../assets/images/nocheck.png" />
                                </div>
                            </div>
                            <div class="item-info" v-show="carditem.id == item.id">
                                <div class="title" style="padding-top: 10px;" v-if="carditem.proportion">
                                    <div>{{ $t('cart76') }} ：{{ carditem.proportion }}</div>
                                </div>
                                <div class="icon-line">
                                    <div class="title" v-if="carditem.telegram">
                                        <div class="unselectable"><a :href="`${carditem.telegram}`" target="_blank"
                                                rel="nofollow" class="button" style="padding-right: 10px;">
                                                <img src="../../assets/images/telegram.png"
                                                    style="width: 26px;height: 26px;" alt="" srcset="">
                                            </a>
                                            <el-button type="warning" @click="handleCopy(carditem.telegram)"
                                                size="small" style="margin-right:10px;border:none" plain>{{
                                                    $t('setup60') }}</el-button>
                                        </div>
                                    </div>
                                    <div class="title" v-if="carditem.whats_app">
                                        <div class="unselectable"> <a :href="`${carditem.whats_app}`" target="_blank"
                                                rel="nofollow" class="button" style="padding-right: 10px;">
                                                <img src="../../assets/images/watch.png"
                                                    style="width: 26px;height: 26px;border-radius: 50%;    " alt=""
                                                    srcset="">
                                            </a>
                                            <el-button type="warning" @click="handleCopy(carditem.whats_app)"
                                                size="small" style="margin-right:10px;border:none" plain>{{
                                                    $t('setup60') }}</el-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="copy" v-if="carditem.paypal_address">
                                    <el-input style="height: 38px;" v-model="carditem.paypal_address" disabled />
                                    <el-button type="warning" @click="handleCopy(carditem.paypal_address)" size="small"
                                        style="margin-left: 10px;height: 38px;border:none">{{ $t('setup60')
                                        }}</el-button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- <div style="padding-top: 10px;" class="title" v-if="carditem.credit_limit">
                        <div>{{$t('cart77')}}：{{carditem.credit_limit}}</div>
                    </div> -->

                </div>
                <template #footer>
                    <div class="dialog-footer">
                        <div @click="setCreateBankOrder()"> {{ $t('cart8') }}</div>
                        <!-- <el-button @click="handleClose">Cancel</el-button>
                        <el-button type="primary" @click="setCreateBankOrder()">
                            {{ $t('cart8') }}
                        </el-button> -->
                    </div>
                </template>
                <!-- </el-dialog> -->
            </el-drawer>
        </div>
    </div>

</template>
<style scoped lang="scss">
.phone {
    display: none;
}

.pc {
    display: flex;
}

.dialogcontent {
    .title {
        font-size: 16px;
        padding: 8px 0;
    }

    .copy {
        padding: 20px 0;
        display: flex;
    }


    .CardList {
        display: block;
        // grid-template-columns: repeat(auto-fit, minmax(98px, 0fr));
        // grid-auto-rows: 50px;
        // grid-gap: 10px;

        .itemCard,
        .checkItemCard {
            width: 100%;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            border: none;
            border-bottom: 1px solid #e4e7ed;
            border-radius: 5px;

            .item-line {
                height: 48px;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .check-icon {
                    width: 16px;
                    height: 16px;
                }
            }

            .item-info {
                padding-bottom: 10px;
            }

            .icon-line {
                display: flex;
                align-items: center;

                span {
                    line-height: 26px;
                }
            }

            // &:hover {
            //     background: #79bbff3b;
            //     border-radius: 5px;
            //     border: 1px solid #79bbff;
            // }
        }

        .checkItemCard {
            display: block;
            // justify-content: center;
            // align-items: center;
            background: #fff;
            // border-radius: 5px;
            // border: 1px solid #79bbff;
        }
    }


}

.dialog-footer {
    >div {
        width: 100%;
        height: 40px;
        background: #ED4D34;
        border-radius: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        font-style: normal;
    }
}

.pc {
    .dialogcontent {

        max-height: 50vh;
        overflow-y: scroll;
    }
}

@media (max-width: 768px) {
    .pc {
        display: none !important;
    }

    .phone {
        display: flex;
    }

    .dialogcontent {
        .title {
            font-size: 14px;
            padding: 8px 0;
        }

        .copy {
            padding: 10px 0;
            display: flex;
        }


        .CardList {
            display: block;
            // grid-template-columns: repeat(auto-fit, minmax(98px, 0fr));
            // grid-auto-rows: 50px;
            // grid-gap: 10px;

            .itemCard,
            .checkItemCard {
                width: 100%;
                // display: flex;
                // justify-content: center;
                // align-items: center;
                border: none;
                border-bottom: 1px solid #e4e7ed;
                border-radius: 5px;

                .item-line {
                    height: 48px;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .check-icon {
                        width: 16px;
                        height: 16px;
                    }
                }

                .item-info {
                    padding-bottom: 10px;
                }

                .icon-line {
                    display: flex;
                    align-items: center;
                }

                // &:hover {
                //     background: #79bbff3b;
                //     border-radius: 5px;
                //     border: 1px solid #79bbff;
                // }
            }

            .checkItemCard {
                display: block;
                // justify-content: center;
                // align-items: center;
                background: #fff;
                // border-radius: 5px;
                // border: 1px solid #79bbff;
            }
        }

    }

    .dialog-footer {
        >div {
            width: 100%;
            height: 40px;
            background: #ED4D34;
            border-radius: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 40px;
            text-align: center;
            font-style: normal;
        }
    }
}
</style>